import { AttachmentSizeLimitMB, TotalAttachmentSizeLimitMB } from "@/common/constants";
import { useAppSettingsStore } from "@/common/stores/persistingStores/app/appSettingsStore";

export function useEmailAttachmentLimits() {
	const totalMB = useAppSettingsStore(
		(state) => state.settings?.emailMaxTotalAttachmentSizeMB ?? TotalAttachmentSizeLimitMB
	);
	const perFileMB = useAppSettingsStore(
		(state) => state.settings?.emailMaxAttachmentSizeMB ?? AttachmentSizeLimitMB
	);
	return {
		totalMB,
		perFileMB,
		totalBytes: totalMB * 1024 * 1024,
		perFileBytes: perFileMB * 1024 * 1024,
	};
}
